import {
  ClearButtons,
  FormatButtons,
  LevelSelect,
  LinkButtons,
  ListButtons,
  QuoteButtons,
  RichTextInput,
  RichTextInputToolbar,
} from "ra-input-rich-text";
import * as React from "react";
import {
  ArrayInput,
  Edit,
  EditProps,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";
import ImageCropInput from "../../creatorsShared/imageCrop/ImageCropInput";
import { StoredImage } from "../../../types";

const BannersEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <ImageCropInput
          slot="banner"
          fullWidth
          sx={{ display: "grid", gridTemplateColumns: " 1.5fr 0fr 1fr" }}
          label={false}
          source="bannerImage"
          format={(value: StoredImage) => {
            if (!value) return [];
            if (typeof value === "string")
              return [
                {
                  src: `${window["location"]["protocol"]}//${window["env"]["apiDomain"]}/uploads/${value}`,
                },
              ];
            return value;
          }}
        />
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="bannerTitle" label="banners.title" />

          <TextInput
            fullWidth
            source="bannerSubtitle"
            label="banners.subtitle"
          />

          <ArrayInput source="bannerSlogans" label="banners.slogans">
            <SimpleFormIterator fullWidth>
              <RichTextInput
                toolbar={
                  <RichTextInputToolbar>
                    <LevelSelect />
                    <FormatButtons />
                    <ListButtons />
                    <LinkButtons />
                    <QuoteButtons />
                    <ClearButtons />
                  </RichTextInputToolbar>
                }
                fullWidth
                source="slogan"
                label="banners.slogan"
              />
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Edit>
  );
};

export default BannersEdit;
